import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { baseURL } from "../../BaseUrl"
//fucntion to retrive the token from the local storage
const getToken = () => localStorage.getItem("workManagement")
// API headers including token
const getAuthHeaders = () => ({
   headers:{
    Authorization:`Bearer ${getToken()}`
   }
})
export const getReportDetails = createAsyncThunk(
    "report/getReportDetails",
    async ({fromD,toD,department_id}) => {
        try{
            const response = await baseURL.get(`/tracking/reports?startDate=${fromD}&endDate=${toD}&department_id=${department_id}`,getAuthHeaders())
            // console.log("response.data===>",response.data)
            return response.data.data
        }catch(error){
            throw error
        }
    }
)
export const reportSlice = createSlice({
    name:"report",
    initialState:{
        reportData:[],
        loading:false,
        error:null,
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(getReportDetails.pending,(state)=>{
            state.loading= false
        })
        .addCase(getReportDetails.fulfilled,(state,action)=>{
            state.loading=false
            state.reportData=action.payload
        })
        .addCase(getReportDetails.rejected,(state,action)=>{
            state.loading=false
            state.error=action.error
        })
    }
})
export const getReportData = (state) => state.report.reportData
export default reportSlice.reducer